<template>
  <div class="edit_password">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <el-form
      :model="ruleFormPassword"
      :rules="rulesPassword"
      ref="ruleFormPassword"
      label-width="100px"
    >
      <el-form-item
        label="原密码"
        prop="oldPassword"
      >
        <el-input
          name="oldPassword"
          type="password"
          v-model="ruleFormPassword.oldPassword"
          placeholder="请输入原密码"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newPassword"
      >
        <el-input
          name="newPassword"
          type="password"
          v-model="ruleFormPassword.newPassword"
          placeholder="至少8位字符，必须包含英文和数字"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码"
        prop="sureNewPassword"
      >
        <el-input
          name="sureNewPassword"
          type="password"
          v-model="ruleFormPassword.sureNewPassword"
          placeholder="确认新密码"
        ></el-input>
      </el-form-item>
      <el-form-item class="submit">
        <el-button
          type="primary"
          @click="submitForm('ruleFormPassword')"
        >保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import APIS from '@/apis/login.js'
import {
  getStore
} from '@/common/utils.js'
export default {
  data () {
    // 检验新密码
    var checkFormNewPassword = (rule, value, callback) => {
      // 至少8位字符，必须包含英文和数字
      let pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/g
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else if (!pattern.test(value)) {
        callback(new Error('至少8位字符，必须包含英文和数字'));
      } else {
        callback();
      }
    }
    // 检验确认密码
    var checkFormSurePassword = (rule, value, callback) => {
      // 至少8位字符，必须包含英文和数字
      if (value === '') {
        callback(new Error('请输入确认密码'));
      } else if (value !== this.ruleFormPassword.newPassword) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    }
    return {
      moduleTitle: '修改密码',
      ruleFormPassword: {
        oldPassword: '',
        newPassword: '',
        sureNewPassword: ''
      },
      rulesPassword: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: checkFormNewPassword, trigger: 'blur' }
        ],
        sureNewPassword: [
          { required: true, validator: checkFormSurePassword, trigger: 'blur' }
        ]
      },
      enterpriseId: ''
    }
  },
  mounted () {
    this.enterpriseId = getStore('enterpriseId')
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postEditPassword()
        }
      })
    },
    // 修改密码的逻辑：
    // 1、根据当前输入的旧密码和登录的账号信息，获取token，如果token能够正确获取，并且与登录时一致，那么可以进行第二步
    // 2、重置密码
    async postEditPassword () {
      let username = getStore('username')
      let params = {
        grant_type: 'password',
        username: username,
        password: this.ruleFormPassword.oldPassword,
        client_id: 'admin-cli'
      }
      let { status, data } = await APIS.potProtocolToken(this.enterpriseId, { data: params, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).catch((err) => {
        if (err && err.response && err.response.status === 401) {
          this.$message.error({
            message: '原始密码不正确，请重新输入'
          })
        }
      })
      if (status === 200) {
        if (data && data.access_token) {
          this.postResetPassword()
        }
      }
    },
    // 重置密码
    async postResetPassword () {
      let params = {
        "type": "password",
        "value": this.ruleFormPassword.newPassword,
        "temporary": false
      }
      let { status } = await APIS.postAuthAdminRealmsResetPassword(this.enterpriseId, { data: params }).catch(() => {
        this.$message.error({
          message: '密码修改失败'
        })
      })
      if (status === 204) {
        this.$message.success({
          message: '密码修改成功'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.edit_password {
  .name {
    margin-bottom: 20px;
    color: #333333;
    font-weight: 600;
  }
}
</style>